import { formatPeriodo } from '@ops/contracts'

/**
 * Períodos del selector. La clave siempre es 'YYYY-MM', que es la clave de todos
 * los datapoints del contrato.
 *
 * Todo se calcula en UTC: si se usara la hora local, el 1 de cada mes a las 21hs
 * de Buenos Aires el panel mostraría el mes siguiente.
 */
export function currentPeriod(now: Date): string {
  const year = now.getUTCFullYear()
  const month = String(now.getUTCMonth() + 1).padStart(2, '0')
  return `${year}-${month}`
}

/** N períodos terminando en el actual, del más nuevo al más viejo. */
export function lastPeriods(now: Date, count: number): string[] {
  const result: string[] = []
  const cursor = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), 1))
  for (let i = 0; i < count; i += 1) {
    result.push(currentPeriod(cursor))
    cursor.setUTCMonth(cursor.getUTCMonth() - 1)
  }
  return result
}

/**
 * '2026-07' → 'Julio 2026'. Reusa `formatPeriodo` del contrato (que devuelve
 * 'julio 2026') y solo le pone la mayúscula que pide una opción de `<select>`.
 * No hay una segunda tabla de meses.
 */
export function formatPeriodLabel(periodo: string): string {
  const texto = formatPeriodo(periodo)
  return texto.charAt(0).toUpperCase() + texto.slice(1)
}
